import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import StockItem from "./StockItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import gql from "graphql-tag";
import "./StockItemsList.css";

class StockItemsList extends Component {

  componentDidMount() {
    this.subscribe(); 
  }

  subscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  } 

  render() {
    let {loading, error, warehouseStock} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    // On Hand = Available + Reserved. Available is what a new order can be
    // promised; Reserved is promised to an order but still in the warehouse;
    // Incoming is on in-transit stock transfers and ordered purchase orders on their way here.
    let tableHeader = List([
      "SKU",
      "Title",
      "On Hand",
      "Reserved",
      "Available",
      "Incoming",
    ])
    return (
      <Table 
        data={fromJS(warehouseStock)} 
        renderer={StockItem} 
        onItemClick={this.handleItemClick.bind(this)}
        tableHeader={tableHeader}
        extraClassName="StockItemsList"
        itemKey="productSku"
        mode="table"
        selected={this.props.selectedId}
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
  }  

}

const WAREHOUSE_STOCK = gql`
  query warehouseStock($warehouseId: ID!, $productType: String) {
    warehouseStock(warehouseId: $warehouseId, productType: $productType) {
      warehouseId
      productSku
      productTitle
      qoh
      reserved
      atp
      incoming
    }
  }
`;

const ON_ADJUSTED_STOCK = gql`
  subscription onAdjustedStock {
    adjustedStock {
      warehouseId
    }
  }
`;

const withQuery = graphql(WAREHOUSE_STOCK, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      warehouseId: props.warehouseFilter,
      productType: props.productFilter
    }
  })
})


const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_ADJUSTED_STOCK,
      updateQuery: (prev, {subscriptionDate}) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

export default connect(null, mapDispatchToProps)(withQuery(StockItemsList));